loadCSS(window.oxygen.css.main);
import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit";
import "lazysizes/plugins/respimg/ls.respimg";
import "picturefill";
import "./container/menuhandler";
import "./container/formHandler";
import "./container/contactForm";
import "./container/areaIsometricOverview";
import { NumberBetween, viewportHeightLisenter } from "./helpers/functions";

if (!Element.prototype.matches) {
  Element.prototype.matches =
    Element.prototype.msMatchesSelector ||
    Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    var el = this;

    do {
      if (Element.prototype.matches.call(el, s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}

NumberBetween();
viewportHeightLisenter();
window.addEventListener("resize", viewportHeightLisenter);
if (document.querySelectorAll("[data-modal-open]").length > 0) {
  import(/* webpackChunkName: "modalHandler" */ "./container/modalHandler");
}

if (
  document.querySelectorAll(".inspiration-icon, .apartment__track-icon")
    .length > 0
) {
  import(
    /* webpackChunkName: "sliderAnimation" */ "./container/sliderAnimation"
  );
}

if (document.querySelectorAll(".simple-list.lazy-list").length > 0) {
  import(
    /* webpackChunkName: "listPageLazyListHandler" */ "./container/listPageLazyListHandler"
  );
}

if (document.querySelectorAll(".apartment-list").length > 0) {
  import(
    /* webpackChunkName: "apartmentListHandler" */ "./container/apartmentList"
  );
}

if (document.querySelectorAll(".hero-arrow").length > 0) {
  import(/* webpackChunkName: "arrow" */ "./container/hero-arrow");
}

if (document.querySelectorAll(".inspiration-spot__slider").length > 0) {
  import(/* webpackChunkName: "slider" */ "./components/slider");
}
if (document.querySelectorAll(".video-volume").length > 0) {
  import(
    /* webpackChunkName: "videoVolume" */ "./container/videoVolumeHandler"
  );
}
